export default "__VITE_ASSET__0SFxUyAF__"